'use client';

import { updateSlag } from '~/apis/user.api';
import { PAGE_KEYS } from '~/const/ballot';
import { getStore } from '~/mobx/AppStore';

export const onSlagChange = async (): Promise<void> => {
    const { ballotStore } = getStore();
    const { selectedSlagId, slagPage } = ballotStore;

    ballotStore.setIsUpdatingSlag(true);

    try {
        const result = await updateSlag(selectedSlagId, slagPage);
        const url = slagPage === PAGE_KEYS.CANDIDATE_PAGE ? `/${PAGE_KEYS.CANDIDATE_PAGE}` : `/`;
        if (result?.success) {
            // If url is current page, reload the page to reflect the changes
            if (window.location.pathname === url) {
                window.location.reload();
                return;
            }
            window.location.href = url;
        }
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to update company selection');
    } finally {
        ballotStore.setIsUpdatingSlag(false);
    }
};
